import React from 'react';

import {hooks} from '../../hooks';
import {custom} from '../../custom';
import {theme} from '../../constants';
import {components} from '../../components';

export const SendEmailOtp: React.FC = () => {
  const navigate = hooks.useAppNavigate();

  const renderHeader = () => {
    return <components.Header goBack={true} title='ایمیل خود را تایید کنید' />;
  };

  const renderContent = () => {
    return (
      <div style={{padding: '20px 20px 20px 20px'}}>
        <p
          style={{
            margin: 0,
            marginBottom: 40,
            color: theme.colors.textColor,
            lineHeight: 1.7,
            fontSize: 16,
            ...theme.fonts.Mulish_400Regular,
            paddingRight: 20,
          }}
        >
          ما یک ایمیل با یک کد تأیید برای شما ارسال کرده ایم.
        </p>
        <custom.InputField
          label='ایمیل'
          placeholder='ایمیل را وارد کنید'
          containerStyle={{marginBottom: 20}}
        />
        <components.Button
          title={'تایید کنید'}
          onClick={() => {
            navigate('/VerifyEmail');
          }}
        />
      </div>
    );
  };

  return (
    <>
      {renderHeader()}
      {renderContent()}
    </>
  );
};
